import { format } from 'date-fns'

/**
 * Two-line date cell: date on top (~12px), time below (~11px, gray) — matching
 * the Samples "Created" column. Columns using this should set
 * `meta: { multiLine: true }` so the table's single-line truncation doesn't
 * flatten it.
 */
export function TwoLineDateCell({
  value,
}: {
  value: string | number | null | undefined
}) {
  if (!value) return <span className="text-gray-400">-</span>

  const parsed = new Date(value)
  if (isNaN(parsed.getTime())) {
    return <span className="text-gray-400">-</span>
  }

  return (
    <div>
      <div className="whitespace-nowrap text-sm">
        {format(parsed, 'MM/dd/yyyy')}
      </div>
      <div className="whitespace-nowrap text-xs text-gray-500">
        {format(parsed, 'h:mm a')}
      </div>
    </div>
  )
}
